import { DefaultQueryParams } from '@frontend/api-utils';
import { ObjectSelectInputV2, ObjectSelectV2Props } from '@frontend/form';
import { PlaylistClient } from '@frontend/playlist/api';
import { Playlist } from '@frontend/playlist/types';
import React, { useState } from 'react';

const ID = 'playlist-select';
export interface PlaylistSelectProps extends ObjectSelectV2Props<Playlist, DefaultQueryParams> {}
/**
 * @deprecated
 */
export const PlaylistSelect = (props: PlaylistSelectProps) => {
    const [v, cV] = useState<Playlist | null>(null);
    return (
        <ObjectSelectInputV2<Playlist, DefaultQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Playlist'}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(arg) => PlaylistClient.fetchPlaylists({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(p) => p.name}
        />
    );
};
